import { Grid } from '@mui/material';
import { RoutalLoader as Loader, RoutalPalette } from '@nx-smartmonkey/ui';

export const LoaderPage = ({ showText = true }: { showText?: boolean }) => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ height: `100%`, zIndex: 1006, backgroundColor: RoutalPalette.neutral02n }}
    >
      <Grid item>
        <Loader />
      </Grid>
    </Grid>
  );
};
